import { bool, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import { Button, Collapse } from 'reactstrap';

import ExpandButton from '../../generic/ExpandButton';

function ProjectEntity({
  onSave,
  onCancel,
  isEditable,
  onEdit,
  isEditing,
  isExpanded,
  onExpansionToggle,
  title,
  children,
  isExpandable,
}) {
  return (
    <div>
      <div className="d-flex mb-2">
        <div className="d-flex align-items-center w-100">
          {isExpandable && (
            <ExpandButton
              expanded={isExpanded}
              className="mr-2 p-absolute"
              onClick={onExpansionToggle}
            />
          )}
          {title}
        </div>
        <div className="d-flex ml-2 mb-1">
          {isEditing ? (
            <>
              <Button className="mr-2" onClick={onSave}>
                Save
              </Button>
              <Button onClick={onCancel}>Cancel</Button>
            </>
          ) : (
            <Button onClick={onEdit} disabled={!isEditable}>
              Edit
            </Button>
          )}
        </div>
      </div>
      <Collapse isOpen={isExpanded}>
        <div className="p-3 border rounded">{children}</div>
      </Collapse>
    </div>
  );
}

export const ProjectEntityPropTypes = {
  onSave: func.isRequired,
  onCancel: func.isRequired,
  onEdit: func.isRequired,
  onExpansionToggle: func.isRequired,
  isEditable: bool.isRequired,
  isEditing: bool.isRequired,
  isExpanded: bool.isRequired,
  isExpandable: bool,
};

ProjectEntity.propTypes = {
  title: oneOfType([string.isRequired, node.isRequired]).isRequired,
  children: oneOfType([string.isRequired, node.isRequired]).isRequired,
  ...ProjectEntityPropTypes,
};

ProjectEntity.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  isExpandable: true,
};

export default ProjectEntity;
